import React from 'react';
export const MoreTestimonials = () => {
  return <section className="mb-10" data-id="element-118">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-119">
        Meer reacties van deelnemers
      </h2>
      <div className="space-y-4" data-id="element-120">
        {/* Liset's testimonial */}
        <div className="flex items-start" data-id="element-121">
          <div className="flex-shrink-0 mr-3" data-id="element-122">
            <div className="w-12 h-12 bg-blue-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-123">
              L
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-124">
            <div className="flex justify-between mb-1" data-id="element-125">
              <span className="font-bold" data-id="element-126">Liset</span>
              <span className="text-gray-500 text-sm" data-id="element-127">21:29</span>
            </div>
            <p data-id="element-128">Super bedankt. Was boeiend en leerzaam.</p>
          </div>
        </div>
        {/* Linda's testimonial */}
        <div className="flex items-start" data-id="element-129">
          <div className="flex-shrink-0 mr-3" data-id="element-130">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-131">
              L
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-132">
            <div className="flex justify-between mb-1" data-id="element-133">
              <span className="font-bold" data-id="element-134">Linda</span>
              <span className="text-gray-500 text-sm" data-id="element-135">21:39</span>
            </div>
            <p data-id="element-136">
              leuk filmpje :-) Zie mezelf en mijn "hondenkleinkids" :)))
              aangenaam verast.
              <br data-id="element-137" />
              Dankjewel voor de masterclass
            </p>
          </div>
        </div>
        {/* Karin and Annemieke testimonials */}
        <div className="flex items-start" data-id="element-138">
          <div className="flex-shrink-0 mr-3" data-id="element-139">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-140">
              K
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-141">
            <div className="flex justify-between mb-1" data-id="element-142">
              <span className="font-bold" data-id="element-143">Karin</span>
              <span className="text-gray-500 text-sm" data-id="element-144">21:40</span>
            </div>
            <p data-id="element-145">Heel erg bedankt, het was heel leerzaam</p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-146">
          <div className="flex-shrink-0 mr-3" data-id="element-147">
            <div className="w-12 h-12 bg-blue-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-148">
              A
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-149">
            <div className="flex justify-between mb-1" data-id="element-150">
              <span className="font-bold" data-id="element-151">Annemieke</span>
              <span className="text-gray-500 text-sm" data-id="element-152">21:40</span>
            </div>
            <p data-id="element-153">heel erg bedankt voor de masterclass! groetjes, Annemieke</p>
          </div>
        </div>
        {/* Jessica's testimonial */}
        <div className="flex items-start" data-id="element-154">
          <div className="flex-shrink-0 mr-3" data-id="element-155">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e2XikCMQaZbQPPWTtN2TFx/Jessica_mail_MCC_2.png" alt="Jessica" className="w-12 h-12 object-cover rounded-md" data-id="element-156" />
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-157">
            <div className="flex justify-between mb-1" data-id="element-158">
              <span className="font-bold" data-id="element-159">Jessica</span>
              <span className="text-gray-500 text-sm" data-id="element-160">aan mij</span>
            </div>
            <p className="mb-2" data-id="element-161">Hi Amee,</p>
            <p className="mb-2" data-id="element-162">Super, het is gelukt. Dankjewel!</p>
            <p className="mb-2" data-id="element-163">
              Ik wilde nog mijn complimenten geven voor de masterclass van
              gisteren. Ik heb menig gratis webinars gevolgd en vond die van jou
              echt wel de beste. Ben benieuwd naar de cursussen!
            </p>
            <p data-id="element-164">Groeten, Jessica</p>
          </div>
        </div>
        {/* Corrie's testimonial */}
        <div className="flex items-start" data-id="element-165">
          <div className="flex-shrink-0 mr-3" data-id="element-166">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-167">
              C
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-168">
            <div className="flex justify-between mb-1" data-id="element-169">
              <span className="font-bold" data-id="element-170">Corrie</span>
              <span className="text-gray-500 text-sm" data-id="element-171">21:40</span>
            </div>
            <p data-id="element-172">Bedankt voor je heldere uitleg! Fijne avond</p>
          </div>
        </div>
      </div>
    </section>;
};